import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from '../app.component';

// PrimeNG Components for demos
import { PrimeNGModule } from 'src/app/shared/primeng.module';

import { ConfirmationService } from 'primeng/api';

import { MarkAsteriskDirectiveModule } from '../directives/mark-asterisk.directive';


import { AdminUsuariosComponent } from './admin-usuarios/admin-usuarios.component';
import { AdminTareasComponent } from './admin-tareas/admin-tareas.component';
import { AdminPerfilesComponent } from './admin-perfiles/admin-perfiles.component';

import { AdministracionService } from './administracion.service';
import { AdministracionRoutingModule } from './administracion-routing.module';
import { AdminReportesComponent } from './admin-reportes/admin-reportes.component';
import { AdminCatalogosComponent } from './admin-catalogos/admin-catalogos.component';
import { FAZILService } from '../core/services/fazil.service';
import { UIService } from '../core/services/ui.service';
import { AdminPlanesComponent } from './admin-planes/admin-planes.component';
import { AdminSuscripcionesComponent } from './admin-planes/admin-suscripciones/admin-suscripciones.component';
import { AdminIndicadoresComponent } from './admin-indicadores/admin-indicadores.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DatesService } from '../core/services/dates.service';
import { SuscripcionBuscadorComponent } from './admin-planes/admin-suscripciones/suscripcion-buscador.component';

@NgModule({
    declarations: [AdminUsuariosComponent, 
        AdminTareasComponent,
        AdminPerfilesComponent, 
        AdminReportesComponent, 
        AdminCatalogosComponent,
        AdminPlanesComponent, 
        AdminSuscripcionesComponent, 
        SuscripcionBuscadorComponent,
        AdminIndicadoresComponent, 
        DashboardComponent],
    bootstrap: [AppComponent],
    imports: [
        CommonModule,
        PrimeNGModule,
        MarkAsteriskDirectiveModule,
        FormsModule,
        ReactiveFormsModule,
        AdministracionRoutingModule
    ],
    providers: [
        FAZILService,
        UIService,
        DatesService,
        AdministracionService,
        ConfirmationService
    ]
})
export class AdministracionModule { }
